/* The review-ranked nine are rendered by Liquid; filters operate only on those nine. */
if (!customElements.get('med-best-sellers')) customElements.define('med-best-sellers', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.grid = this.querySelector('[data-best-grid]');
    this.form = this.querySelector('[data-best-filter-form]');
    if (!this.grid || !this.form) return;
    this.cards = [...this.grid.querySelectorAll('[data-best-card]')].map((node, rank) => {
      let data; try { data = JSON.parse(node.querySelector('[data-best-data]').textContent); } catch (_) { return null; }
      const text = [data.title,data.type,...(data.tags || [])].join(' ').toLowerCase();
      const options = data.options || [];
      const colors = options.filter(o => /colou?r|finish|metal/i.test(o.name)).flatMap(o => o.values.map(v => typeof v === 'string' ? v : v.name)).filter(Boolean);
      const finishText = text + ' ' + colors.join(' ').toLowerCase();
      const finishes = [];
      if (/\bsilver\b/.test(finishText)) finishes.push('Silver');
      if (/rose.?gold/.test(finishText)) finishes.push('Rose gold');
      if (/\bgold\b/.test(finishText.replace(/rose.?gold/g,''))) finishes.push('Gold');
      if (/\bblack\b/.test(finishText)) finishes.push('Black');
      const styles = ['Leather','Silicone','Beaded','Chain','Cuff','Stretch','Magnetic'].filter(v => text.includes(v.toLowerCase()));
      const categories = [];
      if (/bracelet/.test(text)) categories.push('Bracelets');
      if (/necklace|pendant|dog tag/.test(text)) categories.push('Necklaces');
      const audiences = [];
      if (/\bwom[ae]n\b/.test(text)) audiences.push('Women');
      if (/\bm[ae]n\b/.test(text)) audiences.push('Men');
      if (/\bkids?\b|\bchildren\b|\bgirls?\b|\bboys?\b/.test(text)) audiences.push('Kids');
      return { node, rank, ...data, facets: { 'Metal finish': finishes, Style: styles, Color: colors, Category: categories, 'For whom': audiences } };
    }).filter(Boolean);
    this.ready = true;
    this.price = this.querySelector('[data-best-price]'); this.sort = this.querySelector('[data-best-sort]');
    this.maxPrice = Math.ceil(Math.max(0,...this.cards.map(c=>c.price))/100);
    this.price.max = String(this.maxPrice); this.price.value = String(this.maxPrice);
    try { this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}); }
    catch (_) { this.money = new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}); }
    const holder=this.querySelector('[data-best-facets]');
    for (const key of ['Metal finish','Style','Color','Category','For whom']) {
      const values=[...new Set(this.cards.flatMap(c=>c.facets[key]))].sort((a,b)=>a.localeCompare(b));
      if (!values.length) continue;
      const group=document.createElement('fieldset'),legend=document.createElement('legend');legend.textContent=key;group.append(legend);
      for (const value of values) {
        const label=document.createElement('label'),input=document.createElement('input'),text=document.createElement('span');
        input.type='checkbox';input.value=value;input.dataset.bestFacet=key;text.textContent=value;label.append(input,text);group.append(label);
      }
      holder.append(group);
    }
    this.form.hidden=false;
    this.form.addEventListener('submit',e=>e.preventDefault());
    this.form.addEventListener('input',()=>this.update());
    this.form.addEventListener('reset',()=>{setTimeout(()=>{this.price.value=String(this.maxPrice);this.update();},0);});
    this.update();
  }
  update() {
    const selected={};
    for(const input of this.form.querySelectorAll('[data-best-facet]:checked'))(selected[input.dataset.bestFacet] ||= []).push(input.value);
    let visible=0;
    for(const card of this.cards){
      const match=card.price<=Number(this.price.value)*100 && Object.entries(selected).every(([key,values])=>values.some(v=>card.facets[key].includes(v)));
      card.node.hidden=!match;if(match)visible++;
    }
    const sort=this.sort.value;
    const ordered=[...this.cards].sort((a,b)=>sort==='price-asc'?a.price-b.price||a.rank-b.rank:sort==='price-desc'?b.price-a.price||a.rank-b.rank:sort==='newest'?b.created-a.created||a.rank-b.rank:a.rank-b.rank);
    for(const card of ordered)this.grid.append(card.node);
    this.querySelector('[data-best-count]').textContent=`${visible} ${visible===1?'item':'items'}`;
    this.querySelector('[data-best-empty]').hidden=visible>0;
    this.querySelector('[data-best-price-label]').textContent=this.money.format(Number(this.price.value));
  }
});
